import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const Download = () => {
    const UrlParams = useParams()
    const navigate = useNavigate()
    let { p1, p2 } = UrlParams

    useEffect(()=>{
        const externalLink = `https://reports-assets-cdn.extramarks.com/local/report/csv/${p1}-${p2}.csv`;
        window.location.href = externalLink;
        setTimeout(function() {
            navigate(-1)
        }, 2000);
    },[])
  return (
    <div>Loading..</div>
  )
}

export default Download